module.exports = __webpack_public_path__ + "static/media/map.a20e5b31.jpg";